import Hls from 'hls.js';
import Vue from 'vue';

export default {
  live: false,
  lang: 'zh-cn',
  hotkey: false,
  autoplay: true,
  video: {
    url: '',
    // url: 'https://doctor.liveplay.guahao.com/live/test-0520.m3u8',
    type: 'customHls',
    // eslint-disable-next-line global-require
    customType: {
      customHls(video) {
        const hls = new Hls();
        hls.loadSource(video.src);
        hls.attachMedia(video);
        Vue.prototype.$hls = hls;
      },
    },
  },
};
